import React, { useContext, KeyboardEvent } from "react";
import Button from "./Button";
import { ModalContext } from "../../contexts/ModalContext";
import StaticImage from "./StaticImage";
import chevronImage from "../../images/icons/chevron.png";

interface IDropdown {
  variant?: string | undefined;
  icon?: undefined;
  modalTitle?: string | undefined;
  modalComponent?: any;
  className?: string;
  size?: string;
  showCaret?: boolean;
  onClick?: () => void;
  children: any;
  onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void;
  tabIndex?: number;
  role?: string;
  "aria-expanded"?: boolean;
  "aria-haspopup"?: string;
  "aria-controls"?: string;
}

export default function Dropdown({
  variant = "tertiary",
  icon = undefined,
  modalTitle = "",
  modalComponent = undefined,
  className = "",
  size = undefined,
  onClick = undefined,
  showCaret = true,
  children,
  onKeyDown,
  tabIndex,
  role,
  "aria-expanded": ariaExpanded,
  "aria-haspopup": ariaHaspopup,
  "aria-controls": ariaControls,
}: IDropdown) {
  const { openModal } = useContext(ModalContext);

  const handleOnClick = () => {
    !modalComponent ? onClick?.() : openModal(modalTitle, modalComponent);
  };

  return (
    <Button
      variant={variant}
      icon={icon}
      onClick={handleOnClick}
      className={`flex justify-between ${className}`}
      size={size}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      role={role}
      aria-expanded={ariaExpanded}
      aria-haspopup={ariaHaspopup}
      aria-controls={ariaControls}
    >
      {children}
      {showCaret && (
        <StaticImage src={chevronImage} alt="" height={6} />
      )}
    </Button>
  );
}
